<div class="facility-info content-without-footer d-flex">
    <app-sprintpay-facility-information
        [disabledZoom]="true"
        [zoomCenterMarker]="9"
        [zoom]="5"
        [isLoading]="isLoading"
        [diasabledZoom]="true"
        class="position-absolute"
        [data]="facilityInformation"
    >
    </app-sprintpay-facility-information>
</div>
